// extracted by mini-css-extract-plugin
export default {"logo_slogan":"daodao-brand-footer-DDLogo__logo_slogan--2upw5","logo_cn":"daodao-brand-footer-DDLogo__logo_cn--2_E27"};